module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-13-eba99fc265e8b1bdf5eb07ff14152595.svg";